module.exports = require("./naq.d.ts");